/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/

// core components
import ReportDefault from "./ReportDefault"; 
import ReportMaster from "./ReportMaster";
import secureLocalStorage from "react-secure-storage";

const Index = (props) => {
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));  

  return (
    <>

      <ReportDefault/>      
      
    </>
  );
};

export default Index;
